import PropTypes from 'prop-types';
import { List, ListItemButton, ListItemIcon, ListItemText, Collapse, Typography, Box } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

// project import
import NavItem from './NavItem';
import { useGetMenuMaster, handlerSetOpenMenuId } from 'api/menu';

export default function NavCollapse({ menu, level }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // only one menu stays open
  const isOpen = menuMaster.openMenuId === menu.id;

  const toggleMenu = () => {
    if (!drawerOpen) return;                       // collapsed mode -> ignore
    handlerSetOpenMenuId(isOpen ? null : menu.id); // toggle
  };

  const Icon = menu.icon;

  return (
    <Box>
      <ListItemButton
        onClick={toggleMenu}
        sx={(theme) => ({
          pl: drawerOpen ? `${level * 28}px` : 0,
          ...(drawerOpen
            ? { justifyContent: 'flex-start' }
            : {
                justifyContent: 'center',
                px: 0,
                mx: 'auto',
                width: '100%'
              }),
          py: 1,

          ...(drawerOpen && isOpen && {
            bgcolor: 'primary.lighter',
            borderRight: '2px solid',
            borderColor: 'primary.main'
          })
        })}
      >
        {Icon && (
          <ListItemIcon
            sx={{
              minWidth: drawerOpen ? 28 : 'unset',
              ...(!drawerOpen && {
                width: 36,
                height: 36,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                borderRadius: 1.5
              })
            }}
          >
            <Icon style={{ fontSize: drawerOpen ? '1rem' : '1.25rem' }} />
          </ListItemIcon>
        )}

        {drawerOpen && (
          <ListItemText primary={<Typography variant="h6">{menu.title}</Typography>} />
        )}

        {drawerOpen && (isOpen ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>

      <Collapse in={drawerOpen && isOpen} timeout="auto" unmountOnExit>
        <List disablePadding>
          {menu.children?.map((item) =>
            item.type === 'collapse'
              ? <NavCollapse key={item.id} menu={item} level={level + 1} />
              : <NavItem key={item.id} item={item} level={level + 1} />
          )}
        </List>
      </Collapse>
    </Box>
  );
}

NavCollapse.propTypes = {
  menu: PropTypes.object,
  level: PropTypes.number
};